<script lang="ts">
import type { PropType } from '@mimir/web/compat/vueCompat';
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VCol, VIcon, VRow, VTooltip } from 'vuetify/lib';

export default defineComponent({
  name: 'InfoBubble',
  components: {
    VCol,
    VIcon,
    VRow,
    VTooltip,
  },
  props: {
    noGutters: {
      type: Boolean,
      default: false,
    },
    tooltipPosition: {
      type: String as PropType<'bottom' | 'top' | 'right' | 'left'>,
      default: 'bottom',
    },
  },
});
</script>

<template>
  <VRow :dense="!noGutters" :no-gutters="noGutters" class="flex-nowrap" align="baseline">
    <VCol cols="auto" v-bind="$attrs">
      <slot />
    </VCol>
    <VCol cols="auto" :class="noGutters ? 'ml-1' : undefined">
      <VTooltip
        :bottom="tooltipPosition === 'bottom'"
        :top="tooltipPosition === 'top'"
        :right="tooltipPosition === 'right'"
        :left="tooltipPosition === 'left'"
      >
        <template #activator="{ on }">
          <VIcon color="strong" small v-on="on">info</VIcon>
        </template>
        <slot name="infotext" />
      </VTooltip>
    </VCol>
    <slot name="append" />
  </VRow>
</template>
